export const environment = {
  production: false,

  key: {
    size: '4096',
    http_access: '$GTrw8ifuioruowu5i4jrkjfldiuvoyfiyweho54o0tricolourfafdarerdvcx9ttrFDSda34',
    public: '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9A5gcTM4peoVgo9ZQ1jS\ni+UTWrqS5bup66ZXUqxKDX69ny/Nbiu96a3S+rgQdfCX9TS7/oSdVs+wI3pA0xQ9\nkEVV1KL5ZCzjTy9WzOJG1xVynN9QYR5ythKYIXjuW3U6/iL8iJddoPCOrLopcCe5\nnmM3lh88c6G2igKCvaGdMVO5JQRnxNK3cFLogBKnJ/uQKh7DYizWLKz00SG8OyV8\nxLrXfBPQYsa/whfEJZfotEMbj2FJPWGvPhu24GVA5cVl7L7csBG9rS+RisV3n7aJ\n1AxDQ2j0U6ZRNw9Tb6NK/siYcJiK0PxhjN3hfgQnCryZlCUsDmquwpCqPYQR43xE\nCwIDAQAB\n-----END PUBLIC KEY-----',
  },

  url: {
    api: {
      administrator: {
        user: '/apiuser/v1/user/',
        profile: '/apiuser/v1/profile/',
        permit: '/apiuser/v1/permit/',
        feature_flags: '/apisecurity/v1/feature-flags/'
      },
      report: {
        report_type: '',
        report: '',
        speciality: '',
        author: ''
      },
      drug: {
        administration: '/apimastertables/v1/administrations/',
        adverse_effect: '/apimastertables/v1/adverseeffects/',
        commercial: '/apimastertables/v1/commertial/',
        commercial_form: '/apimastertables/v1/commertialform/',
        contraindication: '/apimastertables/v1/contraindiction/',
        drug: '/apidrug/v1/drug/',
        drug_adverse_effect: '/apidrug/v1/drugadverseeffect/',
        drug_contraindication: '/apidrug/v1/drugcontraindication/',
        drug_interaction: '/apidrug/v1/druginteraction/',
        drug_pathology: '/apidrug/v1/drugpathology/',
        drug_warning: '/apidrug/v1/drugwarning/',
        drug_subtype: '/apimastertables/v1/drugsubtype/',
        drug_type: '/apimastertables/v1/drugtype/',
        drug_generic: '/apidrug/v1/druggeneric/',
        drug_generic_administration: '/apidrug/v1/druggenericadministration/',
        drug_generic_commercial: '/apidrug/v1/druggenericcommercial/',
        drug_generic_commercial_form: '/apidrug/v1/druggenericcommercialform/',
        drug_publish: '/apidrug/v1/publish/',
        formula: '/apimastertables/v1/formula/',
        frequency_quantity: '/apimastertables/v1/frequencyquantity/',
        frequency_time: '/apimastertables/v1/frequencytime/',
        modifier: '/apimastertables/v1/modifier/',
        laboratory: '/apimastertables/v1/laboratory/',
        pathology: '/apimastertables/v1/pathology/',
        pharmaceutical_form: '/apimastertables/v1/pharmaceuticalform/',
        severity: '/apimastertables/v1/severity/',
        situation: '/apimastertables/v1/situation/',
        treatment: '/apitreatment/v1/treatment/',
        treatment_dose: '/apitreatment/v1/treatmentdose/',
        treatment_dose_value: '/apitreatment/v1/treatmentdosevalue/',
        treatment_dose_duration: '/apitreatment/v1/treatmentdoseduration/',
        treatment_dose_weight: '/apitreatment/v1/treatmentdoseweight/',
        treatment_dose_frequency: '/apitreatment/v1/treatmentdosefrequency/',
        treatment_dose_clearance: '/apitreatment/v1/treatmentdoseclearance/',
        treatment_publish: '/apitreatment/v1/publish/',
        unit_measure: '/apimastertables/v1/unitmeasure/'
      },
      congress: {
        event: '/apicongress/v1/event/',
        migrate: '/apicongress/v1/migrate/',
        congress_sponsor: '/apicongress/v1/sponsor/',
        sponsor: '/apimastertables/v1/sponsor/',
        sponsor_type: '/apimastertables/v1/sponsortype/',
      },
      vaccine: {
        crud: '/apivaccine/v1/crud/',
        conditions: '/apivaccine/v1/conditions/',
        evaluation: '/apivaccine/v1/evaluation/',
        schedule: '/apivaccine/v1/schedule/'
      },
      storage: {
        storage: '',
        storage_pdf: ''
      },
      security: {
        login: '/apisecurity/v1/login/',
        refresh_token: '/apisecurity/v1/login/newtoken',
        revoke_token: ''
      }
    }
  }
};
